module.exports = "/_next/static/images/golfActive@3x-c566f2bf8b6f956934e0fe0a82b11d56.png";